export default {
      id: "Icon--lockClosed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--lockClosed",
      toString: function () {
        return this.url;
      }
    }